module.exports = __webpack_public_path__ + "16e865b610cc96a9182a054bbaa52620.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/796.png
// module id = 1703
// module chunks = 2